// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1pJiV","gfeWrapper":"CalendarEvent_gfeWrapper__3mG0N"};